import { useState } from 'react'
import { customerData } from '../../../utilities/CustomerData'

export default function DashboardReferAFriend() {
  const [customerReferralCode, setCustomerReferralCode] = useState(customerData.customerReferralCode)
  const [copiedReferralCode, setCopiedReferralCode] = useState(false)

  const handleCopyReferralCode = () => {
    navigator.clipboard.writeText(customerReferralCode.referralCode)
    setCopiedReferralCode(true)
    setTimeout(() => {
      setCopiedReferralCode(false)
    }, 3000)
  }

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-white mb-10'>
      <div className='flex flex-col items-center p-6'>
        <p className='text-center mb-6 text-gray-600 text-lg'>Use this referral code for you and a friend to get $50 off your fee!</p>
        <div className='bg-gray-100 p-4 rounded-lg flex flex-col items-center'>
          <p className='text-gray-500 mb-1'>Your Referral Code:</p>
          <div className='flex items-center space-x-3'>
            <p className='font-bold text-4xl tracking-widest text-gray-900'>
              {customerReferralCode.referralCode}
            </p>
            {copiedReferralCode ? (
              <div className='flex items-center space-x-1'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 16 16'
                  width='22'
                  height='22'
                  fill='green'
                >
                  <path d='M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z'></path>
                </svg>
              </div>
            ) : (
              <svg
                onClick={() => handleCopyReferralCode()}
                className='cursor-pointer text-gray-600 hover:text-blue-500 transition-colors'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 16 16'
                width='18'
                height='18'
              >
                <path d='M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z'></path>
                <path d='M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z'></path>
              </svg>
            )}
          </div>
        </div>
        <p className='text-center text-gray-600 text-lg mt-10'>You have referred <span className='font-bold text-black'>{customerReferralCode.numOfUse}</span> {customerReferralCode.numOfUse === 1 ? 'friend' : 'friends'}, where <span className='font-bold text-black'>{customerReferralCode.numHaveRefund}</span> have calculated a refund! (<span className='font-bold text-black'>${customerReferralCode.numHaveRefund*50}</span> in referrals)</p>
        <p className='text-gray-600 font-light text-xs italic mt-10'>(NOTE: In order for a referral to go into effect, the referree must have successfully calculated a refund)</p>
      </div>
    </div>
  )
}